import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  class: "breadcrumbs__link",
  href: "/"
}, " Home ", -1)
const _hoisted_2 = ["href", "aria-current"]

import { ref, onMounted, nextTick } from 'vue'

  
  import { defineComponent } from 'vue'
  import { Splide, SplideSlide } from '@splidejs/vue-splide'

  const __default__ = defineComponent({
    name: 'AppBreadcrumbs',
    components: {
      Splide,
      SplideSlide,
    },
  })

  interface SplideInstance {
    extensions: any,
    go: () => any,
    hasTrack: Boolean,
    index: Number,
    length: Number,
    splide: any,
    root: HTMLElement,
  }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showHome: {
      type: Boolean,
      default: true,
    },
    breadcrumbs: {
      type: Array, // { title: string, url: string }[]
      default: () => [],
    },
  },
  setup(__props) {

const props = __props

  

  const maxBreadcrumbTextLength = ref(125)
  const breadcrumbSlider = ref<SplideInstance | null>(null)
  const breadcrumbs = ref(props.breadcrumbs as Record<string, string>[])

  // For more info on Splide options, see: https://splidejs.com/v3/guides/options/
  const options = {
    // Font-Awesome faArrowRight
    arrowPath: 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z',
    autoWidth: true,
    focus    : 0,
    omitEnd  : true,
    pagination: false,
    rewind: false,
  }

  /**
   * Returns the value with HTML tags stripped
   */
  const stripTags = (value: string) => {
    if (!value || typeof value !== 'string') return ''
    return value.replace(/<\/?[^>]+(>|$)/g, "")
  }

  /**
   * Truncates the value at the provided character count (length) and appends the suffix
   */
  const truncate = (value: string, length: number, suffix: string) => {
    if (!value || typeof value !== 'string') return ''
   
    if (value.length > length) {
      return value.substring(0, length) + suffix
    }

    return value
  }

  /**
   * Adjusts the carousel's arrow svg viewbox value
   * Splide arrow svg viewbox values are too small for font-awesome icons
   */
  const updateSvgViewbox = (viewBoxValue: string) => {
    const prevArrowSvg = document.querySelector('.splide__arrow--prev svg')
    const nextArrowSvg = document.querySelector('.splide__arrow--next svg')

    // Get the arrow elements and filter out null values
    let carouselArrowSvgList = [
      prevArrowSvg, 
      nextArrowSvg
    ].filter((el): el is Element => el !== null)

    // Update the viewbox values
    carouselArrowSvgList.forEach((svg) => {
      svg.setAttribute('viewBox', viewBoxValue)
    })
  }

  /**
   * Handles when to show / hide the carousel arrows
   */
  const updateArrows = async () => {

    // Wait for the DOM to update
    await nextTick()

    // Stop execution if the carousel reference is null or if the carousel element (root) is null
    if (breadcrumbSlider.value === null || breadcrumbSlider.value.root === null) {
      return
    }

    // Get the track and list of slides
    let track = breadcrumbSlider.value.splide.Components.Elements.track as HTMLElement
    let slides = breadcrumbSlider.value.splide.Components.Elements.slides as HTMLElement[]
    let slidesTotalWidth = 0

    // Get the carousel element
    let carouselId = breadcrumbSlider.value.root.getAttribute('id') || null
    let carouselEl = carouselId ? document.getElementById(carouselId) : null

    // Calculate the total width of all slides
    slides.forEach((slide: HTMLElement) => {
      slidesTotalWidth += slide.offsetWidth
    })
    
    // If the carousel was properly loaded
    if (carouselEl !== null) {
      // Check if the arrows should be shown (track width is less than width of all slides)
      if (slidesTotalWidth > track.offsetWidth) {
        carouselEl.classList.add('show-arrows')
        carouselEl.classList.remove('full-width')
      } else {
        // Hide the arrows and adjust the carousel to use the now empty space that the arrows were using
        carouselEl.classList.remove('show-arrows')
        carouselEl.classList.add('full-width')
      }
    }
  }

  /**
   * Changes the length of breadcrumb text allowed before being truncated based on screen width
   */
  const updateBreadcrumbText = () => {
    let page = document.getElementById('main')
    if (!page) return

    let pageWidth = page.offsetWidth
    
    if (pageWidth >= 1024) {
      maxBreadcrumbTextLength.value = 125
    } 
    else if (pageWidth >= 768) {
      maxBreadcrumbTextLength.value = 95
    }
    else if (pageWidth >= 480) {
      maxBreadcrumbTextLength.value = 50
    }
    else if (pageWidth <= 480) {
      maxBreadcrumbTextLength.value = 25
    }
  }

  /**
   * Handles running methods that update the carousel
   */
  const updateCarousel = () => {
    // Update the breadcrumb text length allowed
    updateBreadcrumbText()

    // Determine if the carousel arrows are needed
    updateArrows()
  }

  onMounted(() => {
    // Update carousel arrow svg viewbox value
    updateSvgViewbox('0 0 448 512')

    // Update the carousel on page load
    updateCarousel()

    // Update the carousel when the screen size changes
    window.addEventListener('resize', updateCarousel)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Splide), {
    ref_key: "breadcrumbSlider",
    ref: breadcrumbSlider,
    options: options,
    class: "breadcrumbs",
    "aria-label": "Breadcrumb Navigation",
    role: "region",
    "aria-roledescription": "Breadcrumb Carousel"
  }, {
    default: _withCtx(() => [
      (__props.showHome)
        ? (_openBlock(), _createBlock(_unref(SplideSlide), { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (breadcrumb, index) => {
        return (_openBlock(), _createBlock(_unref(SplideSlide), { key: index }, {
          default: _withCtx(() => [
            (breadcrumb.url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass({ 
            'breadcrumbs__current': Number(index) === breadcrumbs.value.length - 1, 
            'breadcrumbs__link': Number(index) !== breadcrumbs.value.length - 1  
          }),
                  href: breadcrumb.url,
                  "aria-current": Number(index) === breadcrumbs.value.length - 1 ? 'page' : undefined
                }, _toDisplayString(truncate(stripTags(breadcrumb.title), maxBreadcrumbTextLength.value, '...')), 11, _hoisted_2))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass({ 
            'breadcrumbs__current': Number(index) === breadcrumbs.value.length - 1, 
            'breadcrumbs__link': Number(index) !== breadcrumbs.value.length - 1  
          })
                }, _toDisplayString(truncate(stripTags(breadcrumb.title), maxBreadcrumbTextLength.value, '...')), 3))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 512))
}
}

})